// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PN3Ns","label":"styles_label__1h_T6"};